// extracted by css-extract-rspack-plugin
export default {"form":"Y0B1OoLlZ6YFoaMx__form___","mentionsAwardsWrapper":"isRmMoa4DEUZSKHx__mentionsAwardsWrapper___"};